<template>
    <div class="activityList-block">
        <div class="no-data" v-if="actList.length === 0">
            <img src="../../assets/images/empty.svg">
            <p>目前沒有活動</p>
        </div>
        <div @click="goDetail(item)"
             v-for="(item, index) in actList" :key="index" class="list">
            <div class="cover">
                <img :src="item.graphImageUrl" v-if="item.graphImageUrl!==''">
                <img src="@/assets/images/default_banner2.svg" v-else>
            </div>
            <h2 class="brand">{{item.name}}</h2>
        </div>
        <infinite-loading @infinite="setupDataScroll" :identifier="infiniteInfinite" ref="infiniteLoading" spinner="waveDots" v-if="setupListData">
            <div slot="no-more">沒有更多資料</div>
            <span slot="no-results"/>
        </infinite-loading>

        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>
    </div>
</template>

<script>
    import * as mutationTypes from '@/store/mutationTypes'
    import crypto from "@/util/crypto";
    export default {
        name: "MarketplaceActivityList",
        props: {
            shopAreaId: { default: 0 }
        },
        data() {
            return {
                isLoading: false,
                setupListData: false,       //是否有載入過初始資料?
                infiniteInfinite: 0,
                infiniteLoadingState: '',
                currentPage: 0,             //目前頁數
                pageSize: 10,
                actList : [],         //活動列表
            }
        },
        mounted() {
            this.setupData();
        },
        methods: {
            setupData() {
                let self = this;
                self.startLoading();
            },
            /** 資料開始載入 */
            startLoading() {
                let self = this;
                self.isLoading = false;
                setTimeout(function(){
                    if (!self.setupListData) {
                        self.setupListData = true;

                        if (self.infiniteLoadingState !==  '') {
                            self.infiniteLoadingState?.reset();
                        }
                    }
                    //改變 infiniteInfinite，才能讓 infinite-loading觸發載入事件
                    self.infiniteInfinite += 1;
                },100)
            },
            /** 下拉載入更多 */
            setupDataScroll($state) {
                let self = this;
                self.infiniteLoadingState = $state
                self.isLoading = true;

                self.getShoppingAreaActList($state)
                    .then( () => {
                        self.isLoading = false;
                    })
                    .catch( (error) => {
                        self.isLoading = false;
                        self.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });
            },
            /** 取得活動列表 */
            getShoppingAreaActList($state) {
                let self = this;
                self.infiniteLoadingState = $state;

                return new Promise(function (resolve, reject) {
                    //活動列表
                    self.$http.fetch`GetShoppingAreaActList${{
                        shopAreaId: self.shopAreaId,
                        offset: self.currentPage,
                    }} ${json => {

                        if (self.$public.notNull(json.data)) {
                            self.currentPage++;
                            self.actList = [...self.actList, ...json.data];

                            if (json.data.length >= self.pageSize) {
                                self.infiniteLoadingState?.loaded();

                            } else {
                                self.infiniteLoadingState?.complete();
                            }

                            //完成
                            resolve();

                        } else {
                            //失敗
                            // self.infiniteLoadingState?.loaded();
                            reject('GetShoppingAreaActList error');
                        }
                    }}`;
                });
            },
            goDetail(item) {
                let routerName = "MarketplaceActivityDetail"
                this.$router.push({name: routerName, query: {code: item.code}})
            },
        }
    }
</script>

<style lang="less" scoped>
    .activityList-block{
        margin-bottom: 50px;
        @media(min-width: 1024px){
            display: flex;
            flex-wrap: wrap;
        }
    }
    .isApp{
        @media(min-width: 1024px){
            .list{
                flex: 0 0 30.2%;
            }
        }
    }
    .list{
        margin: 20px;
        box-shadow: var(--box-shadow);
        padding: 12px;
        border-radius: 16px;
        transition: opacity .3s ease;
        cursor: pointer;
        &:active , &:hover{
            opacity: .8;
        }
        @media(min-width: 1024px){
            margin: 20px 0 0 20px;
            flex: 0 0 30.7%;
        }
        .brand{
            margin-bottom: 0;
        }
    }
    .cover{
        width: 100%;
        border-radius: 12px;
        overflow: hidden;
        img{
            object-fit: cover;
            height: 100%;
        }
    }
    .infinite-loading-container{
        flex: 0 0 100%;
        margin-top: 20px;
    }
</style>